(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1673],{

/***/ 31673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _public_home_participation1_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54309);
/* harmony import */ var _public_home_participation1_svg__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_public_home_participation1_svg__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _public_home_participation2_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36093);
/* harmony import */ var _public_home_participation2_svg__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_public_home_participation2_svg__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _public_home_Quizhub_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94983);
/* harmony import */ var _public_home_Quizhub_svg__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_public_home_Quizhub_svg__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _public_home_Certhub_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41348);
/* harmony import */ var _public_home_Certhub_svg__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_public_home_Certhub_svg__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(61608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_6__);







var HomeParticipation = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "usage-container py-md-3 px-md-5 py-5 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row g-0",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col pt-md-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "usage-title text-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "color",
                                            children: " Engage "
                                        }),
                                        "and  ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "color",
                                            children: "Reward"
                                        }),
                                        " Participants"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "sub-text w-75 mx-auto text-center",
                                    children: "You can use QuizHub to engage participants with live quizzing and CertHub for automatically issuing participation certificates on feedback submission"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "row g-0 mt-4",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "col-10 offset-1 text-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "g-0 pb-md-5 d-flex umbrella-sites justify-content-center align-items-center flex-grow mt-4 pt-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "site-card p-4 d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                src: (_public_home_Quizhub_svg__WEBPACK_IMPORTED_MODULE_4___default()),
                                                className: "logos ms-1 mb-3",
                                                alt: "KonfHub Online Quiz",
                                                width: 141,
                                                height: 70
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "section-text",
                                                children: "QuizHub brings you live quizzes to gamify & simplify tech learning. Participate in a quiz, a tournament or even make your own!"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: "_blank",
                                                className: "width-small",
                                                href: "https://quiz.konfhub.com",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "learn-more d-flex align-items-center mt-4",
                                                    children: [
                                                        "Learn more  ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            class: "fas ms-2 fa-arrow-right"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                src: (_public_home_participation1_svg__WEBPACK_IMPORTED_MODULE_2___default()),
                                                className: "participation-1",
                                                alt: "quizhub image",
                                                width: 500,
                                                height: 340
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "site-card p-4 d-flex flex-column",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                src: (_public_home_Certhub_svg__WEBPACK_IMPORTED_MODULE_5___default()),
                                                className: "logos ms-1",
                                                alt: "certhub logo",
                                                width: 141,
                                                height: 70
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "section-text",
                                                children: "Collect feedback from participants and/or automatically issue customized participation certificates on feedback submission."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                target: "_blank",
                                                className: "width-small",
                                                href: "https://cert.konfhub.com",
                                                rel: "noopener noreferrer",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                    className: "learn-more d-flex align-items-center mt-4",
                                                    children: [
                                                        "Learn more  ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                            class: "fas ms-2 fa-arrow-right"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                src: (_public_home_participation2_svg__WEBPACK_IMPORTED_MODULE_3___default()),
                                                className: "participation-2",
                                                alt: "Generate certification for quiz instantly",
                                                width: 500,
                                                height: 340
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                children: "\n      .usage-container {\n          background: #f6f9fc;\n      }\n\n      .usage-container .usage-title {\n          color: #572148;\n          font-weight: 800;\n          font-size: 50px;\n          font-family: \"Nunito\";\n      }\n      .color{\n          color: #fb5850;\n      }\n      .section-text{\n        font-family: Nunito;\n        font-size: 20px;\n        font-weight: 500;\n        line-height: 28px;\n        letter-spacing: 0px;\n        text-align: left;\n        color: #FFFFFF;\n      }\n      .width-small{\n        width: fit-content;\nblock-size: fit-content;\n\n      }\n      .learn-more{\n        font-family: Nunito;\n        font-size: 17px;\n        font-weight: 800;\n        line-height: 26px;\n        letter-spacing: 0px;\n        cursor: pointer;\n        text-align: left;\n        color: #ffffff;\n      }\n      .learn-more:hover{\n        color: #fb5850;\n      }\n      .participation-1{\n        margin-right: -185px;\n      }\n      .participation-2{\n        margin-right: -270px;\n      }\n      .sub-text{\n          font-family: 'Nunito';\n          font-style: normal;\n          font-weight: 500;\n          font-size: 20px;\n          text-align: center;\n          color: #4F4F4F;\n      }\n      .logos{\n        margin-left: -12px;\n        height: 120px;\n        width: 170px;\n      }\n      .umbrella-sites{\n        flex-direction: row;\n        gap: 50px;\n      }\n      .site-card{\n        width: 612px;\n        height: 620px;\n        overflow: hidden;\n        text-align: left !important;\n        background: #572148;\n        box-shadow: 4px 4px 30px rgba(0, 0, 0, 0.25);\n        border-radius: 10px;\n      }\n\n      /* XS screens */\n      @media only screen and (max-width: 768px) {\n        .usage-container .usage-title {\n            font-size: 35px;\n        }\n      }\n\n      /* XS screens */\n      @media only screen and (max-width: 480px) {\n        .site-card{\n          width: 320px;\n        }\n        .umbrella-sites{\n          flex-direction: column;\n        }\n      }\n\n      /* XS screens */\n      @media (min-width: 480px) and (max-width: 992px) {\n          .site-card{\n            width: 450px;\n          }\n          .umbrella-sites{\n            flex-direction: column;\n          }\n      }\n  "
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (HomeParticipation);


/***/ }),

/***/ 41348:
/***/ (function(module) {

module.exports = "/_next/static/images/Certhub-cea17a25807d217bf695a7dc639fff43.svg";

/***/ }),

/***/ 94983:
/***/ (function(module) {

module.exports = "/_next/static/images/Quizhub-c79afb29411b697d2c9e69866b89d965.svg";

/***/ }),

/***/ 54309:
/***/ (function(module) {

module.exports = "/_next/static/images/participation1-6ae92fd5da5d35eb3b0573048a503bf0.svg";

/***/ }),

/***/ 36093:
/***/ (function(module) {

module.exports = "/_next/static/images/participation2-e05e52cdce044ae4bd63baf6307cc007.svg";

/***/ })

}]);